<template>
  <div class="data-atlas-container " id="chart"></div>
</template>
<script>
import * as echarts from "echarts";
import { getDataSetAtlas } from "@/api/index";
export default {
  data() {
    return {
      chart: null
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      var { result } = await getDataSetAtlas({ id: this.$route.params.id });
      this.chart = echarts.init(document.getElementById("chart"));
      var option = {
        tooltip: {
          trigger: "item",
          triggerOn: "mousemove"
        },
        series: [
          {
            type: "tree",

            data: [result],

            top: "18%",
            bottom: "14%",

            layout: "radial",

            symbol: "emptyCircle",

            symbolSize: 7,

            initialTreeDepth: 3,

            animationDurationUpdate: 750,

            emphasis: {
              focus: "descendant"
            }
          }
        ]
      };
      this.chart.setOption(option);
    }
  }
};
</script>
<style lang="scss" scoped>
.data-atlas-container {
  width: 100%;
  background: #ffffff;
  border: 1px solid #eeeeee;
  height: 1000px;
}
</style>
